import React, { useState } from "react";
import { Collapse, Input } from "antd";
import { useTranslation } from "react-i18next";
import { Wand2 } from "lucide-react";
import { PromptUnknownTokensNote } from "pages/Welcome/PromptUnknownTokensNote";

/**
 * Accordion editor for Map / Reduce org LLM prompts (large-review path).
 * Only one phase is expanded at a time so the active textarea uses full width.
 */
export function PromptMapReduceAccordion({
  styles,
  metricId,
  mapValue,
  onMapChange,
  reduceValue,
  onReduceChange,
  mapRef,
  reduceRef,
  canEdit,
  mapInputId = "welcome-prompt-map-phase",
  reduceInputId = "welcome-prompt-reduce-phase",
  defaultActiveKey = "map",
}) {
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState(defaultActiveKey);

  return (
    <Collapse
      accordion
      bordered={false}
      activeKey={activeKey}
      onChange={(key) => setActiveKey(key || defaultActiveKey)}
      className={styles.promptMapReduceAccordion}
    >
      <Collapse.Panel
        key="map"
        header={
          <span className={styles.promptPhaseAccordionLabel}>
            <Wand2 size={15} />
            {t("welcome.promptPhaseMap")}
          </span>
        }
      >
        <Input.TextArea
          id={mapInputId}
          className={`${styles.promptEditorTextarea} ${styles.promptEditorTextareaAccordion}`}
          value={mapValue}
          onChange={onMapChange}
          placeholder={t("welcome.promptPlaceholderMap")}
          ref={mapRef}
          readOnly={!canEdit}
          autoSize={{ minRows: 22, maxRows: 48 }}
        />
        <PromptUnknownTokensNote metricId={metricId} text={mapValue} />
      </Collapse.Panel>

      <Collapse.Panel
        key="reduce"
        header={
          <span className={styles.promptPhaseAccordionLabel}>
            <Wand2 size={15} />
            {t("welcome.promptPhaseReduce")}
          </span>
        }
      >
        <Input.TextArea
          id={reduceInputId}
          className={`${styles.promptEditorTextarea} ${styles.promptEditorTextareaAccordion}`}
          value={reduceValue}
          onChange={onReduceChange}
          placeholder={t("welcome.promptPlaceholderReduce")}
          ref={reduceRef}
          readOnly={!canEdit}
          autoSize={{ minRows: 22, maxRows: 48 }}
        />
        <PromptUnknownTokensNote metricId={metricId} text={reduceValue} />
      </Collapse.Panel>
    </Collapse>
  );
}
